import React from 'react';
import { FuelIcon } from '@frete.com/fuel-react';
import useAmplitude from '@hooks/useAmplitude';
import { JourneysItemInterface, JourneyStatusType } from '@interface/journeys';
import BullhornIcon from '@assets/svg/bullHornIcon.svg';
import { CREATED_BY_OPTION_ONE, CREATED_BY_OPTION_TWO } from '@constants';
import {
  openCompanyEvaluating,
  OpenRateDriver,
} from '@utils/companyEvaluating/companyEvaluating';
import * as Styled from '../JourneyListStyles';

export interface KebabListProps extends JourneysItemInterface {
  openModalConfirm?: () => void;
  closeBottonSheet?: () => void;
  onClickUnrecognized?: (id: string) => void;
  onClickCancelJourney?: (
    id: string,
    depositFee: JourneysItemInterface['trucker']['depositFee'],
  ) => void;
}

function KebabList(props: KebabListProps) {
  const {
    openModalConfirm,
    closeBottonSheet,
    id,
    onClickUnrecognized,
    onClickCancelJourney,
    status,
    trucker,
    created,
  } = props;
  const { amplitudeEvent } = useAmplitude();

  function handleEvaluating() {
    openCompanyEvaluating(id);
    amplitudeEvent('company_evaluating_dropdown', {
      travelId: id || '',
    });
  }

  function handlerConfirmDelivery() {
    const statusNotAllowedShow = ['unrecognized', 'canceled'];

    if (statusNotAllowedShow.includes(status.slug)) {
      return null;
    }

    return (
      <li>
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();

            openModalConfirm?.();
            closeBottonSheet?.();
          }}
          data-testid="confirmar-entrega-kebab-list"
        >
          <FuelIcon name="double-check" />
          Confirmar entrega
        </button>
      </li>
    );
  }

  function handlerOptionsKebabList(journeyStatus: JourneyStatusType) {
    const journeyStatusDoneByTrucker = journeyStatus === 'done_by_trucker';
    const journeyStatusDoneCanceledUnrecognized =
      journeyStatus === 'done' ||
      journeyStatus === 'canceled' ||
      journeyStatus === 'unrecognized';
    const journeyStatusInProgress = journeyStatus === 'in_progress';
    const journeyStatusPendingRoute = journeyStatus === 'pending_route';
    const journeyStatusRefused = journeyStatus === 'refused';
    const journeyStatusExpired =
      journeyStatus === 'refused' &&
      status.by &&
      ['system:lifetime', 'system:freight'].includes(status.by);

    if (
      journeyStatusInProgress &&
      created.by &&
      CREATED_BY_OPTION_ONE.includes(created.by)
    ) {
      return (
        <>
          {handlerConfirmDelivery()}
          <li>
            <button
              type="button"
              data-testid="cancel-journey"
              onClick={(event) => {
                event.stopPropagation();

                amplitudeEvent('journey_canceled_kebabList');
                onClickCancelJourney?.(id, trucker.depositFee);
                closeBottonSheet?.();
              }}
            >
              <FuelIcon name="close" size="small" />
              Cancelar viagem
            </button>
          </li>
          <li>
            <button
              type="button"
              data-testid="button-unrecognized"
              onClick={(event) => {
                event.stopPropagation();

                onClickUnrecognized?.(id);
                closeBottonSheet?.();
              }}
            >
              <FuelIcon name="remove-user" />
              Não reconheço esta viagem
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                handleEvaluating();
                closeBottonSheet?.();
              }}
            >
              <FuelIcon name="stars-multiple" />
              Avaliar motorista
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                OpenRateDriver(id);
                amplitudeEvent('company_dispute_request');
                closeBottonSheet?.();
              }}
            >
              <Styled.IconMenuKebab role="img" src={BullhornIcon} />
              Abrir reclamação
            </button>
          </li>
        </>
      );
    }
    if (
      journeyStatusInProgress &&
      created.by &&
      CREATED_BY_OPTION_TWO.includes(created.by)
    ) {
      return (
        <>
          {handlerConfirmDelivery()}
          <li>
            <button
              type="button"
              data-testid="cancel-journey"
              onClick={(event) => {
                event.stopPropagation();

                amplitudeEvent('journey_canceled_kebabList');
                onClickCancelJourney?.(id, trucker.depositFee);
                closeBottonSheet?.();
              }}
            >
              <FuelIcon name="close" size="small" />
              Cancelar viagem
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                handleEvaluating();
                closeBottonSheet?.();
              }}
            >
              <FuelIcon name="stars-multiple" />
              Avaliar motorista
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                OpenRateDriver(id);
                amplitudeEvent('company_dispute_request');
                closeBottonSheet?.();
              }}
            >
              <Styled.IconMenuKebab role="img" src={BullhornIcon} />
              Abrir reclamação
            </button>
          </li>
        </>
      );
    }

    if (journeyStatusDoneByTrucker) {
      return (
        <>
          {handlerConfirmDelivery()}
          <li>
            <button
              type="button"
              onClick={() => {
                handleEvaluating();
                closeBottonSheet?.();
              }}
            >
              <FuelIcon name="stars-multiple" />
              Avaliar motorista
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                OpenRateDriver(id);
                amplitudeEvent('company_dispute_request');
                closeBottonSheet?.();
              }}
            >
              <Styled.IconMenuKebab role="img" src={BullhornIcon} />
              Abrir reclamação
            </button>
          </li>
        </>
      );
    }

    if (journeyStatusDoneCanceledUnrecognized) {
      return (
        <>
          <li>
            <button
              type="button"
              onClick={() => {
                handleEvaluating();
                closeBottonSheet?.();
              }}
            >
              <FuelIcon name="stars-multiple" />
              Avaliar motorista
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                OpenRateDriver(id);
                amplitudeEvent('company_dispute_request');
                closeBottonSheet?.();
              }}
            >
              <Styled.IconMenuKebab role="img" src={BullhornIcon} />
              Abrir reclamação
            </button>
          </li>
        </>
      );
    }

    if (journeyStatusPendingRoute) {
      return (
        <>
          {handlerConfirmDelivery()}
          <li>
            <button
              type="button"
              data-testid="button-unrecognized"
              onClick={(event) => {
                event.stopPropagation();

                onClickUnrecognized?.(id);
                closeBottonSheet?.();
              }}
            >
              <FuelIcon name="remove-user" />
              Não reconheço esta viagem
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                handleEvaluating();
                closeBottonSheet?.();
              }}
            >
              <FuelIcon name="stars-multiple" />
              Avaliar motorista
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                OpenRateDriver(id);
                amplitudeEvent('company_dispute_request');
                closeBottonSheet?.();
              }}
            >
              <Styled.IconMenuKebab role="img" src={BullhornIcon} />
              Abrir reclamação
            </button>
          </li>
        </>
      );
    }

    if (journeyStatusRefused || journeyStatusExpired) {
      return (
        <li>
          <button
            type="button"
            onClick={() => {
              OpenRateDriver(id);
              amplitudeEvent('company_dispute_request');
              closeBottonSheet?.();
            }}
          >
            <Styled.IconMenuKebab role="img" src={BullhornIcon} />
            Abrir reclamação
          </button>
        </li>
      );
    }

    return (
      <li>
        <button
          type="button"
          onClick={() => {
            handleEvaluating();
            closeBottonSheet?.();
          }}
        >
          <FuelIcon name="stars-multiple" />
          Avaliar motorista
        </button>
      </li>
    );
  }

  return (
    <Styled.KebabList>
      <>{handlerOptionsKebabList(status.slug)}</>
    </Styled.KebabList>
  );
}

export default KebabList;
